export const menuSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: '320px',
  paddingBottom: '4px',
};

export const sectionHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 16px 4px',
};

export const selectAllButtonStyles = {
  minWidth: 'auto',
  padding: '0 4px',
  textTransform: 'none',
};

export const authorRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 16px 6px 8px',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },

  '& .MuiFormControl-root': {
    width: 'auto',
    margin: 0,
  },

  '& .MuiFormControlLabel-root': {
    margin: 0,
  },
};

export const getAuthorAvatarStyles = color => ({
  width: '28px',
  height: '28px',
  fontSize: '1.1rem',
  fontWeight: 500,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: ({ palette }) => color || palette.border.input,
});

export const authorTextStyles = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minWidth: 0,
};

export const authorTitleStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const getAuthorDotStyles = color => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: ({ palette }) => color || palette.border.input,
});

export const truncatedTextStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
